import axios from "axios";
import { common } from "../../utils";
import { API_URL } from "../../utils/api-utils";

export const GetListJobScheduleQuota = async (param) => {
  let url = `${API_URL.Loader}/api/Job/GetListJobScheduleQuota`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};
export const DeleteJobScheduleQuota = async (param) => {
  let url = `${API_URL.Loader}/api/Job/DeleteJobScheduleQuota`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const GetListJobScheduleHistory = async (param) => {
  let url = `${API_URL.Loader}/api/Job/GetListJobScheduleHistory`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const CheckDuplicateQuata = async (param) => {
  let url = `${API_URL.Loader}/api/Job/CheckDuplicateQuata`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};
export const SaveJobScheduleQuota = async (param) => {
  let url = `${API_URL.Loader}/api/Job/SaveJobScheduleQuota`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const GetJobScheduleQuotaInfo = async (param) => {
  let url = `${API_URL.Loader}/api/Job/GetJobScheduleQuotaInfo`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};


